import React from "react";
import { Component } from "react";
import ButtonIcon from "../../button";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { extractAction } from '../../../store/external/extract-reducer/extract.reducer';
import Translation from "../translation/translation.component";


class CustomExportButton extends Component {
    constructor(props){
        super(props);
        this.state={
            showModal:false,
            ppt: false,
            toggle: false,
            charts: [],
            extractAlertMsg: "",

        }

        this.buttonRef = React.createRef();
    }

    componentDidMount() {

        document.addEventListener('click', this.handleDocumentClick);

    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleDocumentClick);
    }

    exportToPowerPoint = async () => {  

        if (window.confirm(this.state.extractAlertMsg)) {
            this.handelPPT();
        }
    };

    exportToPDF = async () => { 

        if (window.confirm(this.state.extractAlertMsg)) {
            this.handelPDF();
        }
    };

    getChart = () => Object.values(this.props.imageRef).map(ref => ref.current);

    handelPPT = async (buttonType)=>{   
        const chart = this.getChart();      
        this.props.printData(true);  
        this.props.exportToPowerPoint(chart, this.props.circuitCode)
        .then(() => this.props.printData(false))
        .catch((error) => console.log(error));
    }

    handelPDF = async (buttonType)=>{

        const chart = this.getChart();  
        this.props.printData(true);  
        this.props.exportToPDF(chart, this.props.circuitCode)
        .then(() => this.props.printData(false))
        .catch((error) => console.log(error)); 
    }
   
    handleDocumentClick = (event) => {

        // Check if the clicked element is not the button
        if (this.buttonRef.current && !this.buttonRef.current.contains(event.target)) {
          this.setState({ toggle: false });

        }
    };

    onChangeExtractAlertMsg = (val, key) => {
        this.setState({
            extractAlertMsg: val
        });
    }

    render(){
        const {customClassName}=this.props

        return(
            <div className={`custom-dropdown-button-container ${customClassName}`} ref={this.buttonRef}>                
                <Translation
                    getOnlyText={true}
                    onChangeTranslation={this.onChangeExtractAlertMsg}
                    translationKey={"export_alert_message"} />
                <ButtonIcon iconLeft="cloud-arrow-down" iconSize="17px" onClick={() => this.setState((prev) => ({ toggle: !prev.toggle }))} customClassName={`${!this.props.isReadOnly ? "header-option-list" : ""} header-filter-button`} labelName="Extract" disabled={this.props.loading}
                    isDisable={this.props.isReadOnly && !this.props.isReadAndExtractOnly && !this.props.isReadAndWrite}/>
                {
                    this.state.toggle && !this.props.isReadOnly ? 
                    <div className="custom-dropdown-list">
                        <ul>
                            <li onClick={this.exportToPDF}>PDF</li>
                            <li onClick={this.exportToPowerPoint}>PowerPoint</li>
                        </ul>
                        </div>
                        :
                        null
                }
            </div>
        )
    }
}

export default connect(
    state => {
        return {};
    },
    dispatch => bindActionCreators(
        Object.assign({}, extractAction),
        dispatch
    )
) (CustomExportButton);